<button class="kz-plan3D-fs--medias-mobile-exit"><kz-icons name="cross"></kz-icons></button>
<div class="kz-diaporama-v2" data-fullscreen="kz-diaporama-v2--fullscreen" appFullscreen *ngIf="($kazaplanMedias | async) as kazaplanMedias">
  <div class="kz-diaporama-container">
    <ng-container *ngFor="let planMedia of kazaplanMedias; let i = index; trackBy: trackMedia;">
      <ng-container *ngIf="i == (kps.getKazaplanCurrentMedia() | async)">
        <kz-loader type="logo" *ngIf="!planMediaLoaded[i]"></kz-loader>
        <img
                class="kz-diaporama-item kz-diaporama-current"
                (load)="planMediaLoaded[i]=true"
                loading="lazy"
                [src]="planMedia.fileUrl"
                alt=""
                *ngIf="planMedia.typeId!=planMediaType.CAPTURE_360"
                border="0">
        <app-kazaplan-360-viewer
                *ngIf="planMedia.typeId==planMediaType.CAPTURE_360"
                [viewportHeight]="'90vh'" [viewportWidth]="'calc(100vw - 38rem)'"
                [imageUrl]="planMedia.fileUrl"
                (isReady)="planMediaLoaded[i]=true"></app-kazaplan-360-viewer>
      </ng-container>
    </ng-container>
  </div>
  <div class="kz-diaporama--nav" [ngClass]="{'kz-diaporama--nav--only-buttons' : kazaplanMedias[(kps.getKazaplanCurrentMedia() | async)]?.typeId == planMediaType.CAPTURE_360}" *ngIf="planMediaLoaded.length > 1">
    <app-diapo-button (click)="previousMedia($event)"></app-diapo-button>
    <app-diapo-button [direction]="'next'" (click)="nextMedia($event)"></app-diapo-button>

  </div>
</div>
<div class="kz-plan3D-fs--medias-actions" style="padding-left: 2rem;">
  <!--
  <a href="#" class="kz-button kz-button--white"><span>Publier</span></a>
  -->

  <!--
  <div class="kz-count">
    <button class="kz-count--follow">
      <span class="kz-iconfont--follow" aria-hidden="true"></span>
      <span class="count-follow">000</span>
    </button>
    <button class="kz-count--like">
      <span class="kz-iconfont--like" aria-hidden="true"></span>
      <span class="count-like">000</span>
    </button>
  </div>
    -->
  <ng-container
          *ngIf="($kazaplanSocialShare | async) as currentMedia">
    <app-social-share
            [postLink]="baseURL + (kps.getKazaplanLocationState() | async)"
            [postDescription]="(kps.getCurrentKazaplan() | async).title"
            [postMainMediaUrl]="currentMedia.fileUrl"
    ></app-social-share>
    <ng-container >
      <div class="kz-remove"
      *ngIf="(currentMedia.typeId != planMediaType.DEFAULT) && (currentMedia.typeId != planMediaType.CAPTURE_AUTO) && (kps.isOwner() | async)">
        <button (click)="deletePlanMedia(currentMedia.id, currentMedia.planId)"><span class="kz-iconfont--trashcan"
                                                                                      aria-hidden="true"></span></button>
      </div>
    </ng-container>
  </ng-container>
</div>
